import type { BrandCampaignSettings, CreditHistoryEntry, CreditPack, Customer, InboundSms } from './types';
import { MOCK_BRAND_ID } from './mockReference';

const DAY_MS = 86_400_000;

export const mockSettings: BrandCampaignSettings = {
  id: 'cset_a2b',
  brandId: MOCK_BRAND_ID,
  createdAt: '2026-06-01T09:00:00Z',
  updatedAt: '2026-09-20T14:30:00Z',
  frequencyCapCount: 4,
  frequencyCapDays: 30,
  quietStartLocal: '21:00',
  quietEndLocal: '08:00',
  smsCreditsBalance: 1840,
  smsCreditPriceCents: 1.5,
  emailFromName: 'A2B',
  emailReplyTo: 'hello@a2b.example',
  postalAddress: 'Princeton, NJ 08540',
  featureEnabled: true,
  defaultAttributionWindowDays: 7,
  automationCheckTime: '10:00',
  brandName: 'A2B',
  brandTimezone: 'America/New_York',
};

/** Larger packs cost less per credit. */
export const mockCreditPacks: CreditPack[] = [
  { id: 'pack_1000', credits: 1000, priceCents: 1500 },
  { id: 'pack_5000', credits: 5000, priceCents: 7000 },
  { id: 'pack_10000', credits: 10000, priceCents: 13000 },
];

export function buildMockCreditHistory(now: Date = new Date()): CreditHistoryEntry[] {
  const rows: [number, CreditHistoryEntry['type'], number, string][] = [
    [1, 'usage', -62, 'Thank you, regulars'],
    [14, 'usage', -118, 'We miss you: at-risk customers'],
    [14, 'refund', 4, 'Carrier rejected 4 messages'],
    [21, 'usage', -84, 'Weekend dosa festival'],
    [30, 'purchase', 2000, 'Credit pack: 2,000'],
    [58, 'usage', -400, 'Automations: August'],
    [90, 'purchase', 500, 'Starter credits'],
  ];
  let balance = mockSettings.smsCreditsBalance;
  return rows.map(([daysBack, type, credits, note], i) => {
    const at = new Date(now.getTime() - daysBack * DAY_MS).toISOString();
    const entry: CreditHistoryEntry = {
      id: `crd_${i + 1}`, brandId: MOCK_BRAND_ID, createdAt: at, updatedAt: at,
      at, type, credits, balanceAfter: balance, note,
    };
    balance -= credits;
    return entry;
  });
}

const INBOUND_BODIES = [
  'please dont text me anymore',
  'Who is this?',
  'take me off your list',
  'What time do you close tonight?',
  'no more messages thanks',
  'Can I book a table for 6 on Friday?',
  'wrong number',
  'Love the new menu!',
];

/** CON-09 — inbound SMS that are not opt-out or help keywords. */
export function buildMockInbound(customers: Customer[], now: Date = new Date()): InboundSms[] {
  const withPhone = customers.filter((c) => c.phone).slice(20, 20 + INBOUND_BODIES.length);
  return withPhone.map((c, i) => {
    const at = new Date(now.getTime() - (i * 7 + 2) * 3_600_000).toISOString();
    return {
      id: `inb_${i + 1}`, brandId: MOCK_BRAND_ID, createdAt: at, updatedAt: at,
      customerId: c.id, customerName: c.name, phoneE164: `+${(c.phone ?? '').replace(/\D/g, '')}`,
      body: INBOUND_BODIES[i], receivedAt: at, status: 'pending',
    };
  });
}
